import { render } from "./AttachRemoveCorporateSitePlan.vue?vue&type=template&id=04fcb045"
import script from "./AttachRemoveCorporateSitePlan.vue?vue&type=script&lang=js"
export * from "./AttachRemoveCorporateSitePlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__